import { checkEnvironment } from '@saviynt/common';

const getRolesEntitlementsApiUrl = () => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/roles/entitlements`;
};

export default getRolesEntitlementsApiUrl;
